import Vue from 'vue'
export default Vue.extend({
  props: {
    value: {
      type: String,
      required: true,
    },
    styles: {
      type: [Object, String],
      required: false,
      default: () => ({})
    },
    classes: {
      type: [Array, String],
      required: false,
      default: () => []
    },
    containerClasses: {
      type: [Array, String],
      required: false,
      default: () => []
    }
  },
  computed: {
    previewMode() {
      return this.$store.state.previewMode
    },
  },
  methods: {
    emitUpdate(event) {
      this.$emit('input', event.target.textContent)
    }
  }
})